








import Vue from 'vue'
import WikiNode from '@/models/wiki/wikiNode'
const MAX_ITERATE = 10;
export default Vue.extend({
  props: {
    parentId: String
  },
  data () {
    return {
      nodes: [] as WikiNode[],
      iterateConter: 0,
      vissible: false
    }
  },
  methods: {
    async loadNode (parentId: string) {
      this.iterateConter++
      if (this.iterateConter > MAX_ITERATE) {
        console.error(`Wiki Nodes breadcrumbs infinite looping! MAX_ITERATE = ${MAX_ITERATE}, this iterate number = ${this.iterateConter}`);
        return false;
      }
      try {
        let node: WikiNode = await this.$store.dispatch('wiki/getNode', parentId);
        this.nodes.push(node);

        let parerent = node.getParentId();
        if (parerent) {
          this.loadNode(parerent);
        } else {
          this.nodes.reverse();
          this.vissible = true;
        }
      } catch (error) {
        console.error(error)
        // @ts-ignore
        this.$message.error(this.$t('labels.can_not_load_node_breadcrumbs'));
      }
    }
  },
  async mounted () {
    await this.loadNode(this.parentId)
  }
})
